import ContactScene from '../../scenes/Contact/Contact';

export default ContactScene;
